import React, { useState, useEffect, useContext } from 'react';

import clsx from 'clsx';

import ProjectCard from '../../components/projectCard/ProjectCard';
import ProjectForCastIcon from '../../assets/svg/ProjectForCastIcon';
import ProjectDocuments from '../../assets/svg/ProjectDocuments';
import DigitalReceipt from '../../assets/svg/DigitalReceipt';
import FileIcon from '../../assets/svg/FileIcon';
import DigitalOrdering from '../../assets/svg/DigitalOrdering';
import ProjectDashboardCardIcon from '../../assets/svg/ProjectDashboard';
import MyWidgets from '../../components/widgets/MyWidgets';
import { AppContext } from '../../context/AppContext';
import ElectronicDoIcon from '../../assets/svg/ElectronicDoIcon';
import UserManagementIcon from '../../assets/svg/UserManagementIcon';
import ApiGatewayIcon from '../../assets/svg/ApiGatewayIcon';
import FeedBackBtn from '../../assets/svg/FeedBackBtn';
import { FeedbackModal } from '../../components/modals/FeedbackModal';
import useDashboardAPI from '../../hooks/network/useDashboardAPI';
import ProjectBlockChart from '../../assets/svg/ProjectBlockChart';

const projectsDetails = [
  {
    code: 'UMP',
    background: '#9CCC65',
    icon: <UserManagementIcon />,
  },
  {
    code: 'AG',
    background: '#78909C',
    icon: <ApiGatewayIcon />,
  },
  {
    code: 'PRD',
    background: '#26A69A',
    icon: <ProjectDashboardCardIcon />,
  },
  {
    code: 'DIGIOS',
    background: '#29B6F6',
    icon: <DigitalOrdering />,
  },
  {
    code: 'DP',
    background: '#FFA726',
    icon: <ProjectDocuments />,
  },
  {
    code: 'DIGIDO',
    background: '#7E57C2',
    icon: <DigitalReceipt />,
  },
  {
    code: 'PBC',
    background: '#EF5350',
    icon: <ProjectBlockChart />,
  },
  {
    code: 'FC',
    background: '#5C6BC0',
    icon: <ProjectForCastIcon />,
  },
  {
    code: 'DPUAT',
    background: '#8D6E63',
    icon: <FileIcon />,
  },
  {
    code: 'ED',
    background: '#78909C',
    icon: <ElectronicDoIcon />,
  },
];

function Dashboard() {
  const [projects, setProjects] = useState([]);
  const { widgetSettings } = useContext(AppContext);
  const [isShowFeedbackMdl, setIsShowFeedbackMdl] = useState(false);
  const { getApplication } = useDashboardAPI();

  useEffect(() => {
    getApplication().then((data) => {
      setProjects(data);
    });
  }, []);

  return (
    <section className='App-dashboard relative h-full w-full'>
      <div
        className={clsx('h-full break:min-h-[calc(100vh-130px)]', {
          'flex flex-col break:flex break:flex-row-reverse': widgetSettings?.selected?.length,
        })}
      >
        {!!widgetSettings?.selected?.length && (
          <div className='break:ml-4 break:w-[45%] breakMax:mb-4'>
            <MyWidgets authToken={projects.find((p) => p?.code === 'DP')?.token} />
          </div>
        )}

        <div
          className={clsx(
            'h-full rounded-xl bg-white p-5',
            { 'min-h-[calc(100vh-100px)]': !widgetSettings?.selected?.length },
            { 'break:w-[55%]': widgetSettings?.selected?.length },
          )}
        >
          <div className={clsx('mb-4', 'break:mb-8')}>
            <h2 className='font-semibold break:text-lg'>All Applications</h2>
          </div>
          <div className='flex h-[calc(100%-46px)] flex-col items-center justify-between break:h-[calc(100%-52px)]'>
            <div
              className={clsx(
                {
                  'grid auto-rows-fr grid-cols-2 flex-wrap content-center justify-center sm:grid-cols-3 md:grid-cols-4 break:grid-cols-5':
                    !widgetSettings?.selected?.length,
                },
                {
                  'grid auto-rows-fr grid-cols-2 flex-wrap content-center sm:grid-cols-3 md:grid-cols-4 break:grid-cols-3 maclg:grid-cols-4':
                    widgetSettings?.selected?.length,
                },
                'gap-x-2 gap-y-5 break:gap-8',
              )}
            >
              {projects.map((project) => {
                const defaultProject = projectsDetails.filter((p) => p.code === project?.code);
                return <ProjectCard key={project?.code} {...defaultProject[0]} {...project} />;
              })}
            </div>

            <div className='mt-5 flex w-full items-center justify-start bg-white'>
              <div className=''>
                <div className='flex flex-wrap items-center gap-3 sm:flex-row'>
                  <div className='text-sm font-semibold break:text-base'>
                    <button
                      type='button'
                      onClick={() => setIsShowFeedbackMdl(true)}
                      className='flex items-center justify-center gap-2 rounded-xl bg-nblue py-1.5 px-3 text-sm text-white break:gap-4 break:py-2.5 break:px-6'
                    >
                      <span className='hidden sm:block'>Feedback </span>
                      <span>
                        <FeedBackBtn />{' '}
                      </span>
                    </button>
                  </div>
                  {/* <div className='text-sm font-semibold break:text-base'>
                    <a to='https://www.natsteel.com.sg/termsandconditions/'>Terms & Conditions</a>
                  </div> */}
                  <div className='text-sm font-semibold break:text-base'>
                    <a href='https://www.natsteel.com.sg/#/AboutUs'>About NatSteel</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isShowFeedbackMdl && (
        <FeedbackModal open={isShowFeedbackMdl} handleClose={() => setIsShowFeedbackMdl(false)} />
      )}
    </section>
  );
}

Dashboard.propTypes = {};

export default React.memo(Dashboard);
